import { setLicenseKey } from 'survey-core';

/**
 * Licença do SurveyJS (Creator + runtime). Sem chave registrada o Survey Creator
 * mostra a faixa "To use the Survey Creator library in your application, a
 * developer license is required…" no rodapé de todo construtor (formulário de
 * candidato e formulário de alinhamento). A chave é um segredo de build:
 * `VITE_SURVEYJS_LICENSE_KEY`, provisionada no cofre e injetada pelo
 * workflow de deploy — nunca no repositório. Sem a variável nada muda.
 */
export function registerSurveyJsLicense(env: { VITE_SURVEYJS_LICENSE_KEY?: string }): boolean {
  const key = env.VITE_SURVEYJS_LICENSE_KEY?.trim();
  if (!key) return false;
  setLicenseKey(key);
  return true;
}

registerSurveyJsLicense(import.meta.env);
